import React from 'react';
import './ColorVariant.css';

function ColorVariant({variant, selected, onClick}) {
    const handleClick = () => {
        if (onClick) onClick(variant.id);
    };

    const hasColor = () => {
        const color = variant.color();
        return !!color;
    };

    const getColor = () => {
        return variant.color();
    };

    const containerStyle = () => {
        return {
            border: `solid 2px ${selected ? '#002EFF' : '#FFFFFF'}`
        };
    };

    const variantStyle = () => {
        return {
            background: getColor() || '#111111'
        };
    };

    return (
        <div className='color-variant' onClick={handleClick} style={containerStyle()}>
            <div className='color-variant_outline' style={variantStyle()}>
                {!hasColor() && <div className='color-variant_no-color'></div>}
            </div>
        </div>
    );
}

export default ColorVariant;